import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { startCase } from "lodash";
import { useFormikContext } from "formik";
import { AddClientFormValues } from "../../types";

function BillingIntervalSelect() {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddClientFormValues>();

  const currentlySelectedPlanIsFreePlan = ["free", "legacy"].includes(
    values["client-pricing-plan"] as string,
  );

  return (
    <Tooltip
      title={
        currentlySelectedPlanIsFreePlan
          ? "No billing interval is required for free plans"
          : ""
      }
    >
      <FormControl
        fullWidth
        sx={{
          marginBottom: "2%",
          marginTop: "2%",
          width: "100%",
          float: "right",
        }}
        variant="standard"
      >
        <InputLabel
          id="client-billing-interval-label"
          htmlFor="client-billing-interval"
        >
          Billing Interval
        </InputLabel>
        <Select
          disabled={currentlySelectedPlanIsFreePlan}
          data-testid="client-billing-interval-edit"
          fullWidth={true}
          id="client-billing-interval"
          name="client-billing-interval"
          value={
            currentlySelectedPlanIsFreePlan
              ? ""
              : values["client-billing-interval"]
          }
          onChange={handleChange}
          error={
            touched["client-billing-interval"] &&
            Boolean(errors["client-billing-interval"])
          }
        >
          {["monthly", "yearly"].map((o) => (
            <MenuItem key={o} value={o}>
              {startCase(o)}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText sx={{ marginLeft: 0 }} color="error">
          {errors["client-billing-interval"]}
        </FormHelperText>
      </FormControl>
    </Tooltip>
  );
}

export default BillingIntervalSelect;
